(function () {
  var API_URL = 'https://api.dermaquestclinical.com/cart-builder-dashboard.php';
  var API_KEY = 'UEfLspdVefKHscohphZiEtLmsQOyVp';
  const GENERATE_ENDPOINT = 'https://api.dermaquestclinical.com/cart-builder-generate.php';
  const QR_ENDPOINT = 'https://api.dermaquestclinical.com/cart-builder-qr.php';
  const EMAIL_ENDPOINT = 'https://api.dermaquestclinical.com/cart-builder-send-email.php';
  const AFFILIATE_OVERVIEW_ENDPOINT = 'https://api.dermaquestclinical.com/cart-builder-affiliate-overview.php';
  var root = document.getElementById('dq-cart-builder-dashboard');

  var dqDashboardLogs = [];

    var dqDashboardPage = 1;
    var dqDashboardLimit = 10;

    var dqDashboardSearch = '';

    var dqDashboardSort = 'date';
    var dqDashboardDirection = 'desc';

    var dqAffiliateConversions = [];
    var dqAffiliatePage = 1;
    var dqAffiliateLimit = 10;


  if (!root) return;

  function money(price) {
    return '$' + (Number(price || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function isAffiliateAccount() {
    return !!(window.dqReferralCode && window.dqIsAffiliate);
  }

  function getDashboardReferralUrl() {
    var referralCode = window.dqReferralCode || '';

    if (!referralCode) {
      return '';
    }

    return (
      'https://dermaquestclinical.com/collections/all' +
      '?rfsn=' +
      encodeURIComponent(referralCode)
    );
  }

  async function generateDashboardQrRequest(data) {
    var formData = new FormData();

    Object.keys(data || {}).forEach(function (key) {
      if (
        data[key] !== undefined &&
        data[key] !== null &&
        data[key] !== ''
      ) {
        formData.append(key, data[key]);
      }
    });

    var response = await fetch(QR_ENDPOINT, {
      method: 'POST',
      body: formData
    });

    var result = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || result.success === false) {
      throw new Error(
        result.message || 'Unable to generate QR.'
      );
    }

    return result;
  }

function fetchDashboard(search, page) {
  var customerId = window.dqCustomerId || '';

  var url =
    API_URL +
    '?customer_id=' + encodeURIComponent(customerId) +
    '&page=' + encodeURIComponent(page || 1) +
    '&limit=' + encodeURIComponent(dqDashboardLimit) +
    '&sort=' + encodeURIComponent(dqDashboardSort) +
    '&direction=' + encodeURIComponent(dqDashboardDirection);

  if (search) {
    url += '&search=' + encodeURIComponent(search);
  }

  return fetch(url).then(function (res) {
    return res.json();
  });
}

function fetchAffiliateOverview(page) {
  var customerId = window.dqCustomerId || '';
  var referralCode = window.dqReferralCode || '';

  var url =
    AFFILIATE_OVERVIEW_ENDPOINT +
    '?customer_id=' + encodeURIComponent(customerId) +
    '&referral_code=' + encodeURIComponent(referralCode) +
    '&page=' + encodeURIComponent(page || 1) +
    '&limit=' + encodeURIComponent(dqAffiliateLimit);

  return fetch(url).then(function (res) {
    return res.json();
  });
}

    function fetchDetail(id) {
    var customerId = window.dqCustomerId || '';

    var url = API_URL +
        '?customer_id=' + encodeURIComponent(customerId) +
        '&id=' + encodeURIComponent(id);

    return fetch(url).then(function (res) {
        return res.json();
    });
    }

    function fetchDetail(id) {
        var url = API_URL +
            '?key=' + encodeURIComponent(API_KEY) +
            '&id=' + encodeURIComponent(id);

        return fetch(url).then(function (res) {
            return res.json();
        });
    }

  function renderDashboard(data) {
    var logs = data.logs || [];
    var pagination = data.pagination || {};
    dqDashboardLogs = data.logs || [];
    root.innerHTML = `
        <div class="dq-dashboard">

        ${
            isAffiliateAccount()
            ? `
                <div class="dq-dashboard-referral">
                    <h5>Your Referral Link</h5>
                    <p>Save & share this link to be credited with commissions.</p>
                    <div class="dq-dashboard-referral__actions">
                        <input
                            type="text"
                            id="dq-dashboard-referral-link"
                            value="${escapeHtml(getDashboardReferralUrl())}"
                            readonly>

                        <button
                            type="button"
                            class="dem-btn"
                            data-dq-copy-referral>
                            Copy Link
                        </button>

                        <button
                            type="button"
                            class="dem-btn"
                            data-dq-generate-referral-qr>
                            Generate QR Code
                        </button>
                    </div>
                </div>
            `
            : ''
        }

        <div class="dq-dashboard-overview-tabs">
            <button
                type="button"
                class="dq-dashboard-overview-tab is-active"
                data-dq-dashboard-tab="cart">
                Cart History
            </button>

            <button
                type="button"
                class="dq-dashboard-overview-tab"
                data-dq-dashboard-tab="referrals">
                Referral Conversions
            </button>
        </div>

        <div
            class="dq-dashboard-overview-panel is-active"
            data-dq-dashboard-panel="cart">

            <h3>Cart History</h3>

            <div class="dq-dashboard-search">
                <input type="search" id="dq-dashboard-search" placeholder="Search email, referral code, or log ID">
                <button type="button" id="dq-dashboard-search-btn">Search</button>
            </div>

            <div id="dq-dashboard-detail"></div>

            <table class="dq-dashboard-table">
                <thead>
                <tr>
                    <th>ID</th>
                    <th class="table-user-th">Professional</th>
                    <th>Recipient</th>
                    <th class="table-user-th">Referral</th>
                    <th>Items</th>
                    <th>Email</th>
                    <th>
                    <button
                        type="button"
                        id="dq-dashboard-sort-date"
                        class="dq-dashboard-sort-btn">
                        Date
                        <span id="dq-dashboard-sort-date-icon">
                        ${dqDashboardDirection === 'asc' ? '↑' : '↓'}
                        </span>
                    </button>
                    </th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody id="dq-dashboard-table-body">
                ${renderDashboardRows(logs)}
                </tbody>
            </table>

            <div id="dq-dashboard-pagination" class="dq-dashboard-pagination">
            ${
                data.pagination && data.pagination.has_more
                ? `
                    <button
                    type="button"
                    id="dq-dashboard-load-more"
                    class="dq-dashboard-load-more">
                    Load More
                    </button>
                `
                : ''
            }
            </div>
        </div>

        <div
            class="dq-dashboard-overview-panel"
            data-dq-dashboard-panel="referrals">

            <h3>Referral Conversions</h3>

            <div id="dq-affiliate-overview-content">
                <p>Loading referral conversions...</p>
            </div>
        </div>
        </div>
    `;

    document.getElementById('dq-dashboard-search-btn').addEventListener('click', function () {
        var value = document.getElementById('dq-dashboard-search').value;
        dqDashboardSearch = value;
        load(value);
    });

    root.querySelectorAll('[data-log-id]').forEach(function (row) {
        row.addEventListener('click', function () {
        loadDetail(row.getAttribute('data-log-id'));
        });
    });
    }


async function generateDashboardQr(button, log) {
  if (!button || !log) {
    showSnackbar('Cart information not found.');
    return;
  }

  if (!log.id || !log.return_url) {
    showSnackbar('Missing cart ID or generated cart URL.');
    return;
  }

  var originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Generating QR...';

  try {
    var formData = new FormData();

    formData.append('log_id', log.id);
    formData.append('return_url', log.return_url);

    var response = await fetch(QR_ENDPOINT, {
      method: 'POST',
      body: formData
    });

    var result = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || result.success === false) {
      throw new Error(result.message || 'Unable to generate QR.');
    }

    var imageUrl = result.qr_url || result.image_url || '';

    if (!imageUrl) {
      throw new Error('QR image URL was not returned.');
    }

    /*
     * Update the initial payload object in memory.
     */
    log.has_qr = true;
    log.image_url = imageUrl;

    /*
     * Update the row menu immediately.
     */
    updateQrMenu(log);

    /*
     * Close the three-dot menu.
     */
    var menu = document.querySelector(
      '[data-dq-menu="' + log.id + '"]'
    );

    if (menu) {
      menu.classList.remove('is-active');
    }

    /*
     * Open the same QR modal used by View QR.
     */
    showQrModal(imageUrl);

    showSnackbar('QR code generated successfully.');

  } catch (error) {
    showSnackbar(error.message || 'Unable to generate QR.');
    button.disabled = false;
    button.textContent = originalText;
  }
}


function updateQrMenu(log) {
  var menu = document.querySelector(
    '[data-dq-menu="' + log.id + '"]'
  );

  if (!menu) return;

  var generateButton = menu.querySelector(
    '[data-dq-generate-qr="' + log.id + '"]'
  );

  if (!generateButton) return;

  var wrapper = document.createElement('div');

  wrapper.innerHTML = `
    <button
      type="button"
      data-dq-view-qr="${log.id}"
      data-image-url="${escapeHtml(log.image_url || '')}">
      View QR
    </button>

    <button
      type="button"
      data-dq-download-qr="${log.id}"
      data-image-url="${escapeHtml(log.image_url || '')}">
      Download QR
    </button>
  `;

  var newButtons = Array.from(wrapper.children);

  newButtons.forEach(function (newButton) {
    menu.insertBefore(newButton, generateButton);
  });

  generateButton.remove();
}


function setButtonLoading(button, text) {
  if (!button) return;

  button.dataset.originalText = button.dataset.originalText || button.innerHTML;
  button.disabled = true;
  button.innerHTML = '<span class="dq-spinner"></span> ' + (text || '');
}

function resetButton(button) {
  if (!button) return;

  button.disabled = false;
  button.innerHTML = button.dataset.originalText || 'Send Email';
}

function renderDetail(data) {
  var detail = document.getElementById('dq-dashboard-detail');
  var log = data.log || {};
  var items = data.items || [];
  var returnUrl = data.return_url || '';
  var qrUrl = data.qr_url || '';

  detail.innerHTML = `
    <div class="dq-dashboard-detail">
      <h3>Cart #${log.id}</h3>

      <p><strong>Customer:</strong> ${escapeHtml((log.customer_first_name || '') + ' ' + (log.customer_last_name || ''))}</p>
      <p><strong>Customer Email:</strong> ${escapeHtml(log.customer_email || '—')}</p>
      <p><strong>Recipient:</strong> ${escapeHtml(log.recipient_name || '—')} / ${escapeHtml(log.recipient_email || '—')}</p>
      <p><strong>Referral Code:</strong> ${escapeHtml(log.referral_code || '—')}</p>
      <p><strong>Email Status:</strong> ${escapeHtml(log.email_status || 'Not Sent')}</p>
      <p><strong>Cart Note:</strong><br>${escapeHtml(log.cart_note || '—')}</p>

      <div class="dq-dashboard-actions">
        <input type="text" readonly value="${escapeHtml(returnUrl)}" id="dq-dashboard-generated-link">

        <button type="button" data-dq-dashboard-copy-link>
          Copy Link
        </button>

        <button type="button" data-dq-dashboard-generate-qr>
          Generate QR
        </button>

        <button type="button" data-dq-dashboard-copy-qr>
          Copy QR
        </button>

        <a href="${escapeHtml(returnUrl)}" target="_blank">
          Open Cart
        </a>
      </div>

      <div class="dq-dashboard-qr-wrap">
        <img src="${escapeHtml(qrUrl)}" id="dq-dashboard-qr-image" alt="" style="max-width:160px;${qrUrl ? '' : 'display:none;'}">
      </div>

      <form id="dq-dashboard-email-form" class="dq-dashboard-email-form">
        <h4>Send Cart by Email</h4>

        <input type="hidden" name="log_id" value="${escapeHtml(log.id)}">
        <input type="hidden" name="generated_link" value="${escapeHtml(returnUrl)}">
        <input type="hidden" name="qr_image" value="${escapeHtml(qrUrl)}">

        <input type="hidden" name="customer_id" value="${escapeHtml(log.customer_id || '')}">
        <input type="hidden" name="customer_email" value="${escapeHtml(log.customer_email || '')}">
        <input type="hidden" name="customer_first_name" value="${escapeHtml(log.customer_first_name || '')}">
        <input type="hidden" name="customer_last_name" value="${escapeHtml(log.customer_last_name || '')}">
        <input type="hidden" name="referral_code" value="${escapeHtml(log.referral_code || '')}">

        <input type="text" name="name" placeholder="Recipient Name" value="${escapeHtml(log.recipient_name || '')}">
        <input type="email" name="email" placeholder="Recipient Email" value="${escapeHtml(log.recipient_email || '')}">
        <textarea name="cart_note" placeholder="Cart note">${escapeHtml(log.cart_note || '')}</textarea>

        <button type="submit">Send Email</button>

        <div class="dq-dashboard-message"></div>
      </form>

      <table class="dq-dashboard-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Variant ID</th>
            <th>Qty</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          ${items.map(function (item) {
            return `
              <tr>
                <td>${escapeHtml(item.product_title)}</td>
                <td>${escapeHtml(item.variant_id)}</td>
                <td>${item.quantity || 1}</td>
                <td>${escapeHtml(item.price_formatted || money(item.price))}</td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    </div>
  `;
}

  function load(search) {

        dqDashboardPage = 1;
        dqDashboardSearch = search || '';

        root.innerHTML = '<p>Loading dashboard...</p>';

        fetchDashboard(dqDashboardSearch, dqDashboardPage).then(function (data) {

            if (!data.success) {
            root.innerHTML =
                '<p>' +
                escapeHtml(data.message || 'Unable to load dashboard.') +
                '</p>';

            return;
            }

            dqDashboardLogs = data.logs || [];

            renderDashboard(data);

        });
        

    }

    async function loadMoreDashboard() {
        var button = document.querySelector('#dq-dashboard-load-more');
        var tbody = document.querySelector('#dq-dashboard-table-body');

        if (!button || !tbody) return;

        button.disabled = true;
        button.textContent = 'Loading...';

        try {
            var nextPage = dqDashboardPage + 1;

            var data = await fetchDashboard(
            dqDashboardSearch,
            nextPage
            );

            if (!data.success) {
            throw new Error(data.message || 'Unable to load more.');
            }

            var newLogs = data.logs || [];

            dqDashboardPage = nextPage;
            dqDashboardLogs = dqDashboardLogs.concat(newLogs);

            tbody.insertAdjacentHTML(
            'beforeend',
            renderDashboardRows(newLogs)
            );

            updateDashboardPagination(data.pagination || {});

        } catch (error) {
            showSnackbar(error.message || 'Unable to load more.');
            button.disabled = false;
            button.textContent = 'Load More';
        }
        }

  function loadDetail(id) {
    fetchDetail(id).then(function (data) {
      if (!data.success) {
        alert(data.message || 'Unable to load cart detail.');
        return;
      }

      renderDetail(data);
    });
  }

  function updateDashboardPagination(pagination) {
    var paginationWrap = document.querySelector(
        '#dq-dashboard-pagination'
    );

    if (!paginationWrap) return;

    if (pagination.has_more) {
        paginationWrap.innerHTML = `
        <button
            type="button"
            id="dq-dashboard-load-more"
            class="dq-dashboard-load-more">
            Load More
        </button>
        `;
    } else {
        paginationWrap.innerHTML = '';
    }
    }
  async function sortDashboardByDate() {
    var sortButton = document.querySelector('#dq-dashboard-sort-date');
    var tbody = document.querySelector('#dq-dashboard-table-body');

    if (!tbody) return;

    dqDashboardDirection =
        dqDashboardDirection === 'asc' ? 'desc' : 'asc';

    dqDashboardPage = 1;

    if (sortButton) {
        sortButton.disabled = true;
    }

    tbody.classList.add('is-loading');

    try {
        var data = await fetchDashboard(
        dqDashboardSearch,
        dqDashboardPage
        );

        if (!data.success) {
        throw new Error(data.message || 'Unable to sort entries.');
        }

        dqDashboardLogs = data.logs || [];

        tbody.innerHTML = renderDashboardRows(dqDashboardLogs);

        var icon = document.querySelector(
        '#dq-dashboard-sort-date-icon'
        );

        if (icon) {
        icon.textContent =
            dqDashboardDirection === 'asc' ? '↑' : '↓';
        }

        updateDashboardPagination(data.pagination || {});

    } catch (error) {
        /*
        * Revert the direction when the request fails.
        */
        dqDashboardDirection =
        dqDashboardDirection === 'asc' ? 'desc' : 'asc';

        showSnackbar(
        error.message || 'Unable to sort entries.'
        );
    } finally {
        tbody.classList.remove('is-loading');

        if (sortButton) {
        sortButton.disabled = false;
        }
    }
    }

function renderDashboardRows(logs) {
    return logs.map(function (log) {
        return `
        <tr id="dq-log-${log.id}">
            <td>${log.id}</td>

            <td class="table-user-td">
            ${escapeHtml(log.customer_name || log.customer_email || '—')}
            </td>

            <td>
            <div class="dq-recipient-name">
                ${escapeHtml(log.recipient_name || '—')}
            </div>

            <div class="dq-recipient-email">
                ${escapeHtml(log.recipient_email || '')}
            </div>
            </td>

            <td class="table-user-td">${escapeHtml(log.referral_code || '—')}</td>
            <td>${log.total_products || 0}</td>

            <td class="dq-email-status">
            ${escapeHtml(log.email_status || 'Not Sent')}
            </td>

            <td>${escapeHtml(log.created_at || '')}</td>

            <td class="dq-dashboard-row-actions">
            <button
                type="button"
                class="dq-dashboard-dots"
                data-dq-menu-toggle="${log.id}">
                ⋯
            </button>

            <div class="dq-dashboard-menu" data-dq-menu="${log.id}">
                ${
                log.has_qr
                    ? `
                    <button
                        type="button"
                        data-dq-view-qr="${log.id}"
                        data-image-url="${escapeHtml(log.image_url || '')}">
                        View QR
                    </button>

                    <button
                        type="button"
                        data-dq-download-qr="${log.id}"
                        data-image-url="${escapeHtml(log.image_url || '')}">
                        Download QR
                    </button>
                    `
                    : `
                    <button
                        type="button"
                        data-dq-generate-qr="${log.id}">
                        Generate QR
                    </button>
                    `
                }

                <button
                type="button"
                data-dq-send-email="${log.id}">
                Send Email
                </button>
            </div>
            </td>
        </tr>
        `;
    }).join('');
}
document.addEventListener('submit', async function (e) {
  var form = e.target.closest('#dq-dashboard-email-form');
  if (!form) return;

  e.preventDefault();

  var submitBtn = form.querySelector('button[type="submit"]');
  var message = form.querySelector('.dq-dashboard-message');

  if (message) {
    message.textContent = '';
  }

  setButtonLoading(submitBtn, 'Sending');

  try {
    var formData = new FormData();

    formData.append('log_id', form.log_id?.value || '');
    formData.append('name', form.name?.value || '');
    formData.append('email', form.email?.value || '');
    formData.append('cart_note', form.cart_note?.value || '');
    formData.append('customer_id', form.customer_id?.value || '');
    formData.append('customer_email', form.customer_email?.value || '');
    formData.append('customer_first_name', form.customer_first_name?.value || '');
    formData.append('customer_last_name', form.customer_last_name?.value || '');
    formData.append('referral_code', form.referral_code?.value || '');
    formData.append('generated_link', form.generated_link?.value || '');
    formData.append('qr_image', form.qr_image?.value || '');

    var response = await fetch(EMAIL_ENDPOINT, {
      method: 'POST',
      body: formData
    });

    var result = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || result.success === false) {
      throw new Error(result.message || 'Unable to send email.');
    }

    if (message) {
      message.textContent = 'Email sent successfully.';
    }

    load();

  } catch (error) {
    if (message) {
      message.textContent = error.message || 'Unable to send email.';
    }
  } finally {
    resetButton(submitBtn);
    submitBtn.textContent = 'Send Email';
  }
});

function showSnackbar(message) {
  var snackbar = document.querySelector('#dq-dashboard-snackbar');

  if (!snackbar) {
    snackbar = document.createElement('div');
    snackbar.id = 'dq-dashboard-snackbar';
    snackbar.className = 'dq-dashboard-snackbar';
    document.body.appendChild(snackbar);
  }

  snackbar.textContent = message;
  snackbar.classList.add('is-active');

  setTimeout(function () {
    snackbar.classList.remove('is-active');
  }, 2200);
}

function showQrModal(qrUrl) {
  var modal = document.querySelector('#dq-dashboard-qr-modal');

  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'dq-dashboard-qr-modal';
    modal.className = 'dq-dashboard-qr-modal';
    document.body.appendChild(modal);
  }

  modal.innerHTML = `
    <div class="dq-dashboard-qr-modal__card">
      <button type="button" class="dq-dashboard-qr-modal__close">×</button>
      <h3>Cart QR Code</h3>
      <img src="${escapeHtml(qrUrl)}" alt="Cart QR Code">
      <a href="${escapeHtml(qrUrl)}" download target="_blank">Download QR</a>
    </div>
  `;

  modal.classList.add('is-active');

  modal.querySelector('.dq-dashboard-qr-modal__close').addEventListener('click', function () {
    modal.classList.remove('is-active');
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.classList.remove('is-active');
    }
  }, { once: true });
}

async function getQrUrlByLogId(id) {
  var data = await fetchDetail(id);

  if (!data.success) {
    throw new Error(data.message || 'Unable to load QR.');
  }

  return data.qr_url || '';
}


function showEmailModal(log) {
  var modal = document.querySelector('#dq-dashboard-email-modal');

  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'dq-dashboard-email-modal';
    modal.className = 'dq-dashboard-email-modal';
    document.body.appendChild(modal);
  }

  modal.innerHTML = `
    <div class="dq-dashboard-email-modal__card">
      <button type="button" class="dq-dashboard-email-modal__close">×</button>

      <h3>Send Cart Email</h3>

      <form id="dq-dashboard-send-email-form">
        <input type="hidden" name="log_id" value="${escapeHtml(log.id)}">
        <input type="hidden" name="generated_link" value="${escapeHtml(log.return_url || '')}">
        <input type="hidden" name="qr_image" value="${escapeHtml(log.image_url || '')}">

        <input type="hidden" name="customer_id" value="${escapeHtml(log.customer_id || '')}">
        <input type="hidden" name="customer_email" value="${escapeHtml(log.customer_email || '')}">
        <input type="hidden" name="customer_first_name" value="${escapeHtml(log.customer_first_name || '')}">
        <input type="hidden" name="customer_last_name" value="${escapeHtml(log.customer_last_name || '')}">
        <input type="hidden" name="referral_code" value="${escapeHtml(log.referral_code || '')}">

        <label>
          Recipient Name
          <input type="text" name="name" value="${escapeHtml(log.recipient_name || '')}" required>
        </label>

        <label>
          Recipient Email
          <input type="email" name="email" value="${escapeHtml(log.recipient_email || '')}" required>
        </label>

        <label>
          Note To Customer
          <textarea name="cart_note">${escapeHtml(log.cart_note || '')}</textarea>
        </label>

        <button type="submit" class="dem-btn">Send Email</button>

        <div class="dq-dashboard-email-message"></div>
      </form>
    </div>
  `;

  modal.classList.add('is-active');

  modal.querySelector('.dq-dashboard-email-modal__close').addEventListener('click', function () {
    modal.classList.remove('is-active');
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.classList.remove('is-active');
    }
  }, { once: true });
}

async function sendDashboardEmail(form, log) {
  var submitBtn = form.querySelector('button[type="submit"]');
  var message = form.querySelector('.dq-dashboard-email-message');

  if (message) {
    message.textContent = '';
  }

  submitBtn.disabled = true;
  submitBtn.textContent = 'Sending...';

  try {
    var formData = new FormData(form);

    var response = await fetch(EMAIL_ENDPOINT, {
      method: 'POST',
      body: formData
    });

    var result = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || result.success === false) {
      throw new Error(result.message || 'Unable to send email.');
    }

    var recipientName = form.name?.value || '';
    var recipientEmail = form.email?.value || '';
    var cartNote = form.cart_note?.value || '';

    log.recipient_name = recipientName;
    log.recipient_email = recipientEmail;
    log.cart_note = cartNote;
    log.email_status = 'sent';

    var row = document.querySelector('#dq-log-' + log.id);

    if (row) {

        var recipientNameCell = row.querySelector('.dq-recipient-name');
        var recipientEmailCell = row.querySelector('.dq-recipient-email');
        var statusCell = row.querySelector('.dq-email-status');

        if (recipientNameCell) {
            recipientNameCell.textContent = recipientName || '—';
        }

        if (recipientEmailCell) {
            recipientEmailCell.textContent = recipientEmail || '';
        }

        if (statusCell) {
            statusCell.textContent = 'sent';
        }
    }

    /*
     * Close the modal and show success.
     */
    var modal = document.querySelector('#dq-dashboard-email-modal');

    if (modal) {
      modal.classList.remove('is-active');
    }

    showSnackbar('Email sent successfully.');

  } catch (error) {
    if (message) {
      message.textContent = error.message || 'Unable to send email.';
    } else {
      showSnackbar(error.message || 'Unable to send email.');
    }
  } finally {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Send Email';
  }
}


function formatAffiliateMoney(value, currency) {
  var number = Number(value || 0);

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(number);
  } catch (error) {
    return '$' + number.toFixed(2);
  }
}

function renderAffiliateRows(conversions) {
  if (!conversions.length) {
    return `
      <tr>
        <td colspan="9" class="dq-dashboard-empty">
          No affiliate conversions found.
        </td>
      </tr>
    `;
  }

  return conversions.map(function (conversion) {
    var products = Array.isArray(conversion.products)
      ? conversion.products.join(', ')
      : '';

    var customer =
      conversion.customer_name ||
      conversion.customer_email ||
      '—';

    return `
      <tr>
        <td>${escapeHtml(conversion.order_id || conversion.id || '—')}</td>
        <td>${escapeHtml(customer)}</td>
        <td>${escapeHtml(products || '—')}</td>
        <td>${escapeHtml(formatAffiliateMoney(conversion.sale_amount, conversion.currency))}</td>
        <td>${escapeHtml(formatAffiliateMoney(conversion.commission, conversion.currency))}</td>
        <td>${escapeHtml(conversion.status || '—')}</td>
        <td>${escapeHtml(conversion.payment_status || '—')}</td>
        <td>${escapeHtml(conversion.created_at || '—')}</td>
        <td>
          <button
            type="button"
            class="dq-affiliate-details-btn"
            data-dq-affiliate-details="${escapeHtml(conversion.id || '')}">
            DETAILS
          </button>
        </td>
      </tr>
    `;
  }).join('');
}

function renderAffiliateOverview(data, append) {
  var affiliateContent = root.querySelector(
    '#dq-affiliate-overview-content'
  );

  if (!affiliateContent) return;

  var conversions = data.conversions || [];

  if (append) {
    dqAffiliateConversions =
      dqAffiliateConversions.concat(conversions);

    var tbody = affiliateContent.querySelector(
      '#dq-affiliate-overview-table-body'
    );

    if (tbody) {
      if (
        dqAffiliateConversions.length &&
        tbody.querySelector('.dq-dashboard-empty')
      ) {
        tbody.innerHTML = '';
      }

      tbody.insertAdjacentHTML(
        'beforeend',
        renderAffiliateRows(conversions)
      );
    }
  } else {
    dqAffiliateConversions = conversions;

    affiliateContent.innerHTML = `
        <table class="dq-dashboard-table dq-affiliate-overview-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Products</th>
              <th>Order Total</th>
              <th>Commission</th>
              <th>Status</th>
              <th>Payment</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody id="dq-affiliate-overview-table-body">
            ${renderAffiliateRows(conversions)}
          </tbody>
        </table>

        <div
          id="dq-affiliate-overview-pagination"
          class="dq-dashboard-pagination">
        </div>
    `;
  }

  updateAffiliatePagination(
    data.pagination || {}
  );
}

function updateAffiliatePagination(pagination) {
  var affiliateContent = root.querySelector(
    '#dq-affiliate-overview-content'
  );

  if (!affiliateContent) return;

  var paginationWrap = affiliateContent.querySelector(
    '#dq-affiliate-overview-pagination'
  );

  if (!paginationWrap) return;

  if (pagination.has_more) {
    paginationWrap.innerHTML = `
      <button
        type="button"
        class="dq-dashboard-load-more"
        data-dq-affiliate-load-more>
        Load More
      </button>
    `;
  } else {
    paginationWrap.innerHTML = '';
  }
}

async function loadAffiliateOverview(append) {
  var affiliateContent = root.querySelector(
    '#dq-affiliate-overview-content'
  );

  if (!affiliateContent) return;

  if (!append) {
    dqAffiliatePage = 1;
    affiliateContent.innerHTML =
      '<p>Loading referral conversions...</p>';
  }

  try {
    var data = await fetchAffiliateOverview(
      dqAffiliatePage
    );

    if (!data.success) {
      throw new Error(
        data.message ||
        'Unable to load affiliate overview.'
      );
    }

    renderAffiliateOverview(
      data,
      !!append
    );
  } catch (error) {
    if (!append) {
      affiliateContent.innerHTML =
        '<p>' +
        escapeHtml(
          error.message ||
          'Unable to load referral conversions.'
        ) +
        '</p>';
    } else {
      showSnackbar(
        error.message ||
        'Unable to load more affiliate conversions.'
      );
    }
  }
}


function affiliateValue(value, fallback) {
  if (
    value === undefined ||
    value === null ||
    value === ''
  ) {
    return fallback || '—';
  }

  return String(value);
}

function affiliateBoolean(value) {
  return value ? 'Yes' : 'No';
}

function showAffiliateDetailsModal(conversion) {
  if (!conversion) {
    showSnackbar('Conversion details not found.');
    return;
  }

  var modal = document.querySelector(
    '#dq-affiliate-details-modal'
  );

  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'dq-affiliate-details-modal';
    modal.className = 'dq-affiliate-details-modal';
    document.body.appendChild(modal);
  }

  var products = Array.isArray(conversion.products)
    ? conversion.products
    : [];

  var productHtml = products.length
    ? `
      <ul class="dq-affiliate-details-modal__products">
        ${products.map(function (product) {
          return `<li>${escapeHtml(product)}</li>`;
        }).join('')}
      </ul>
    `
    : '—';

  modal.innerHTML = `
    <div class="dq-affiliate-details-modal__card">
      <button
        type="button"
        class="dq-affiliate-details-modal__close">
        ×
      </button>

      <h3>Conversion Details</h3>

      <div class="dq-affiliate-details-modal__section">
        <h4>REFERRED CUSTOMER</h4>

        <div class="dq-affiliate-details-modal__grid">
          <div>
            <span>Name</span>
            <strong>${escapeHtml(affiliateValue(conversion.customer_name))}</strong>
          </div>

          <div>
            <span>Email</span>
            <strong>${escapeHtml(affiliateValue(conversion.customer_email))}</strong>
          </div>
        </div>
      </div>

      <div class="dq-affiliate-details-modal__section">
        <h4>CONVERSION</h4>

        <div class="dq-affiliate-details-modal__grid">
          <div>
            <span>Order</span>
            <strong>${escapeHtml(affiliateValue(conversion.order_id || conversion.id))}</strong>
          </div>

          <div>
            <span>Conversion ID</span>
            <strong>${escapeHtml(affiliateValue(conversion.id))}</strong>
          </div>

          <div>
            <span>Order Total</span>
            <strong>${escapeHtml(formatAffiliateMoney(conversion.sale_amount, conversion.currency))}</strong>
          </div>

          <div>
            <span>Commissionable Amount</span>
            <strong>${escapeHtml(formatAffiliateMoney(conversion.commissionable_amount, conversion.currency))}</strong>
          </div>

          <div>
            <span>Commission</span>
            <strong>${escapeHtml(formatAffiliateMoney(conversion.commission, conversion.currency))}</strong>
          </div>

          <div>
            <span>Total Items</span>
            <strong>${escapeHtml(affiliateValue(conversion.total_items, '0'))}</strong>
          </div>

          <div>
            <span>Status</span>
            <strong>${escapeHtml(affiliateValue(conversion.status))}</strong>
          </div>

          <div>
            <span>Payment Status</span>
            <strong>${escapeHtml(affiliateValue(conversion.payment_status))}</strong>
          </div>

          <div>
            <span>Type</span>
            <strong>${escapeHtml(affiliateValue(conversion.type))}</strong>
          </div>

          <div>
            <span>Created</span>
            <strong>${escapeHtml(affiliateValue(conversion.created_at))}</strong>
          </div>

          <div>
            <span>Updated</span>
            <strong>${escapeHtml(affiliateValue(conversion.updated_at))}</strong>
          </div>
        </div>
      </div>

      <div class="dq-affiliate-details-modal__section">
        <h4>OTHER DETAILS</h4>

        <div class="dq-affiliate-details-modal__grid">
          <div>
            <span>Payment ID</span>
            <strong>${escapeHtml(affiliateValue(conversion.payment_id))}</strong>
          </div>

          <div>
            <span>Recurring</span>
            <strong>${affiliateBoolean(conversion.is_recurring)}</strong>
          </div>

          <div>
            <span>Test Conversion</span>
            <strong>${affiliateBoolean(conversion.is_test_conversion)}</strong>
          </div>

          <div>
            <span>Offer ID</span>
            <strong>${escapeHtml(affiliateValue(conversion.offer_id))}</strong>
          </div>

          <div>
            <span>Coupon Code</span>
            <strong>${escapeHtml(affiliateValue(conversion.coupon_code))}</strong>
          </div>

          <div>
            <span>Subscription ID</span>
            <strong>${escapeHtml(affiliateValue(conversion.subscription_id))}</strong>
          </div>

          <div>
            <span>Denied Reason</span>
            <strong>${escapeHtml(affiliateValue(conversion.denied_reason_code))}</strong>
          </div>

          <div class="dq-affiliate-details-modal__wide">
            <span>Products</span>
            <div>${productHtml}</div>
          </div>

          <div class="dq-affiliate-details-modal__wide">
            <span>Reason</span>
            <strong>${escapeHtml(affiliateValue(conversion.reason))}</strong>
          </div>

          <div class="dq-affiliate-details-modal__wide">
            <span>Notes</span>
            <strong>${escapeHtml(affiliateValue(conversion.notes))}</strong>
          </div>
        </div>
      </div>
    </div>
  `;

  modal.classList.add('is-active');

  modal
    .querySelector('.dq-affiliate-details-modal__close')
    .addEventListener('click', function () {
      modal.classList.remove('is-active');
    });

  modal.addEventListener(
    'click',
    function (e) {
      if (e.target === modal) {
        modal.classList.remove('is-active');
      }
    },
    { once: true }
  );
}

async function loadMoreAffiliateOverview(button) {
  if (!button) return;

  button.disabled = true;
  button.textContent = 'Loading...';

  var previousPage = dqAffiliatePage;
  dqAffiliatePage += 1;

  try {
    var data = await fetchAffiliateOverview(
      dqAffiliatePage
    );

    if (!data.success) {
      throw new Error(
        data.message ||
        'Unable to load more affiliate conversions.'
      );
    }

    renderAffiliateOverview(
      data,
      true
    );
  } catch (error) {
    dqAffiliatePage = previousPage;
    button.disabled = false;
    button.textContent = 'Load More';

    showSnackbar(
      error.message ||
      'Unable to load more affiliate conversions.'
    );
  }
}


function switchDashboardTab(tab) {
  root.querySelectorAll('[data-dq-dashboard-tab]').forEach(function (button) {
    button.classList.toggle(
      'is-active',
      button.getAttribute('data-dq-dashboard-tab') === tab
    );
  });

  root.querySelectorAll('[data-dq-dashboard-panel]').forEach(function (panel) {
    panel.classList.toggle(
      'is-active',
      panel.getAttribute('data-dq-dashboard-panel') === tab
    );
  });

  if (
    tab === 'referrals' &&
    !dqAffiliateConversions.length
  ) {
    loadAffiliateOverview(false);
  }
}

document.addEventListener('click', async function (e) {
    var dashboardTab = e.target.closest('[data-dq-dashboard-tab]');
    var affiliateDetails = e.target.closest('[data-dq-affiliate-details]');
    var affiliateLoadMore = e.target.closest('[data-dq-affiliate-load-more]');

    if (dashboardTab) {
        e.preventDefault();

        switchDashboardTab(
            dashboardTab.getAttribute('data-dq-dashboard-tab')
        );

        return;
    }

    if (affiliateDetails) {
        e.preventDefault();

        var conversionId = affiliateDetails.getAttribute(
            'data-dq-affiliate-details'
        );

        var conversion = dqAffiliateConversions.find(
            function (item) {
                return String(item.id) === String(conversionId);
            }
        );

        showAffiliateDetailsModal(conversion);
        return;
    }

    if (affiliateLoadMore) {
        e.preventDefault();
        loadMoreAffiliateOverview(affiliateLoadMore);
        return;
    }

    var copyReferralBtn = e.target.closest('[data-dq-copy-referral]');
    var generateReferralQrBtn = e.target.closest('[data-dq-generate-referral-qr]');

    if (copyReferralBtn) {
        e.preventDefault();

        var referralUrl = getDashboardReferralUrl();

        if (!referralUrl) {
            showSnackbar('Referral code not found.');
            return;
        }

        try {
            await navigator.clipboard.writeText(referralUrl);
            showSnackbar('Referral link copied.');
        } catch (error) {
            showSnackbar('Unable to copy referral link.');
        }

        return;
    }

    if (generateReferralQrBtn) {
        e.preventDefault();

        var referralCode = window.dqReferralCode || '';
        var referralUrl = getDashboardReferralUrl();

        if (!referralCode || !referralUrl) {
            showSnackbar('Referral code not found.');
            return;
        }

        var originalText = generateReferralQrBtn.textContent;

        generateReferralQrBtn.disabled = true;
        generateReferralQrBtn.textContent = 'Generating QR...';

        try {
            var result = await generateDashboardQrRequest({
                referral_code: referralCode,
                return_url: referralUrl
            });

            var qrUrl = result.qr_url || '';

            if (!qrUrl) {
                throw new Error('QR image URL was not returned.');
            }

            showQrModal(qrUrl);
            showSnackbar('Referral QR generated successfully.');

        } catch (error) {
            showSnackbar(
                error.message || 'Unable to generate referral QR.'
            );
        } finally {
            generateReferralQrBtn.disabled = false;
            generateReferralQrBtn.textContent = originalText;
        }

        return;
    }

    var menuToggle = e.target.closest('[data-dq-menu-toggle]');
    var viewQr = e.target.closest('[data-dq-view-qr]');
    var downloadQr = e.target.closest('[data-dq-download-qr]');
    var sendEmail = e.target.closest('[data-dq-send-email]');

    var copyLinkBtn = e.target.closest('[data-dq-dashboard-copy-link]');
    var generateQrBtn = e.target.closest('[data-dq-dashboard-generate-qr]');
    var copyQrBtn = e.target.closest('[data-dq-dashboard-copy-qr]');

    var generateQr = e.target.closest('[data-dq-generate-qr]');
    var viewQr = e.target.closest('[data-dq-view-qr]');
    var downloadQr = e.target.closest('[data-dq-download-qr]');
    var sendEmail = e.target.closest('[data-dq-send-email]');
    var sortBtn = document.querySelector('#dq-dashboard-sort-date');
    var loadMoreBtn = document.querySelector('#dq-dashboard-load-more');
    var sortDate = e.target.closest('#dq-dashboard-sort-date');

    if (sortDate) {
        e.preventDefault();
        sortDashboardByDate();
    return;
    }

    document.querySelectorAll('.dq-dashboard-menu').forEach(function (menu) {
        if (!menuToggle || menu.dataset.dqMenu !== menuToggle.dataset.dqMenuToggle) {
            menu.classList.remove('is-active');
        }
    });

    if (sortBtn) {

        sortBtn.addEventListener('click', function () {

            dqDashboardDirection =
                dqDashboardDirection === 'asc'
                    ? 'desc'
                    : 'asc';

            load(dqDashboardSearch);

        });

    }

    if (loadMoreBtn) {

        loadMoreBtn.addEventListener(
            'click',
            loadMoreDashboard
        );

    }

    if (menuToggle) {
        e.preventDefault();

        var menu = document.querySelector('[data-dq-menu="' + menuToggle.dataset.dqMenuToggle + '"]');

        if (menu) {
        menu.classList.toggle('is-active');
        }

        return;
    }

    if (viewQr) {
        e.preventDefault();

        var qrUrl = viewQr.dataset.imageUrl || '';

        if (!qrUrl) {
            showSnackbar('QR image not found.');
            return;
        }

        showQrModal(qrUrl);
        return;
        }

        if (downloadQr) {
        e.preventDefault();

        var qrUrl = downloadQr.dataset.imageUrl || '';

        if (!qrUrl) {
            showSnackbar('QR image not found.');
            return;
        }

        var link = document.createElement('a');
        link.href = qrUrl;
        link.download = 'dermaquest-cart-qr.png';
        link.target = '_blank';
        link.click();

        return;
    }

    if (sendEmail) {
        
        e.preventDefault();

        var id = sendEmail.dataset.dqSendEmail;
        var log = dqDashboardLogs.find(function (item) {
            return String(item.id) === String(id);
        });
        console.log(log)
        if (!log) {
            showSnackbar('Cart log not found.');
            return;
        }

        showEmailModal(log);
        return;
    }

    if (copyLinkBtn) {
        e.preventDefault();

        var link = document.querySelector('#dq-dashboard-generated-link')?.value || '';

        copyText(link, copyLinkBtn, 'Copy Link');
        return;
    }

    if (generateQrBtn) {
        e.preventDefault();

        var form = document.querySelector('#dq-dashboard-email-form');
        var qrImage = document.querySelector('#dq-dashboard-qr-image');

        if (!form) return;

        var logId = form.log_id?.value || '';
        var returnUrl = form.generated_link?.value || '';

        if (!logId || !returnUrl) {
        alert('Missing cart link.');
        return;
        }

        setButtonLoading(generateQrBtn, 'Generating QR');

        try {
        var formData = new FormData();
        formData.append('log_id', logId);
        
        
        formData.append('return_url', log.return_url);

        var response = await fetch(QR_ENDPOINT, {
            method: 'POST',
            body: formData
        });

        var result = await response.json().catch(function () {
            return {};
        });

        if (!response.ok || result.success === false) {
            throw new Error(result.message || 'Unable to generate QR.');
        }

        form.qr_image.value = result.qr_url || '';

        if (qrImage) {
            qrImage.src = result.qr_url || '';
            qrImage.style.display = result.qr_url ? 'block' : 'none';
        }

        } catch (error) {
        alert(error.message || 'Unable to generate QR.');
        } finally {
        resetButton(generateQrBtn);
        }

        return;
    }

    if (copyQrBtn) {
        e.preventDefault();

        var form = document.querySelector('#dq-dashboard-email-form');
        var qrUrl = form?.qr_image?.value || document.querySelector('#dq-dashboard-qr-image')?.src || '';

        copyQrImage(qrUrl, copyQrBtn);
        return;
    }

    if (generateQr) {
        e.preventDefault();

        var id = generateQr.getAttribute('data-dq-generate-qr');

        var log = dqDashboardLogs.find(function (item) {
            return String(item.id) === String(id);
        });

        if (!log) {
            showSnackbar('Cart log not found.');
            return;
        }

        generateDashboardQr(generateQr, log);
        return;
    }
});

    document.addEventListener('submit', function (e) {
        var form = e.target.closest('#dq-dashboard-send-email-form');

        if (!form) return;

        e.preventDefault();

        var logId = form.log_id?.value || '';

        var log = dqDashboardLogs.find(function (item) {
            return String(item.id) === String(logId);
        });

        if (!log) {
            showSnackbar('Cart log not found.');
            return;
        }

        sendDashboardEmail(form, log);
    });

  load();
})();